import { render } from "./LicenseUpload.vue?vue&type=template&id=8dc8a486"
import script from "./LicenseUpload.vue?vue&type=script&lang=js"
export * from "./LicenseUpload.vue?vue&type=script&lang=js"

import "./LicenseUpload.vue?vue&type=style&index=0&id=8dc8a486&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__